import {
  HttpClient
} from '@angular/common/http';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
} from '@angular/core';
import {
  Observable, Subscription
} from 'rxjs';
import { SharedService } from 'src/app/shared.service';
import Utils from 'src/app/utils';
import { TreeDataService } from 'src/app/tree-data.service';
@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html'
})
export class TextEditorComponent implements OnInit, OnDestroy {

  editorConfig = {
    'editable': true,
    'spellcheck': true,
    'height': '250px',
    'minHeight': '0',
    'width': 'auto',
    'minWidth': '0',
    'translate': 'yes',
    'enableToolbar': true,
    'showToolbar': true,
    'placeholder': 'Enter text here...',
    'imageEndPoint': '',
    'toolbar': [
      ['bold', 'italic', 'underline', 'strikeThrough', 'superscript', 'subscript'],
      ['horizontalLine', 'orderedList', 'unorderedList'],
      ['fontName'],
      ['removeFormat'],
      ['link']
    ]
  };

  @Input() fieldValue; // holds the value of the field
  @Input() metadata; // holds the metadata info for which the rte is clicked
  @Input() showCancel = true; // holds boolean whether to show cancel button or not
  @Input() showUpdateBtn = true; // holds boolean whether to show update button or not
  @Input() updateBtnText = 'Done';
  @Output() updateField: EventEmitter<any>; // emits updated object from rte to node details
  @Output() updateFieldOnChange: EventEmitter<any>; // emits updated object from rte on change text
  @Output() updateShowEditor: EventEmitter<any>; // emits boolean for showing editor based on controls clicked
  formControlName; // holds the formControlName
  isPasting = false; // holds flag for pasting text from outside
  maxLimitExceeds = false; // holds boolean value to indicate if source code has exceeded max char limit
  // holds boolean value to indicate if full_statement string has single or
  // multiple backslash '\\'
  containsBackslash = false;
  // holds alert message to be displayed if the user has entered backslash '\\'.
  noBackslash = '';
  nodeCategory = null; // holds the category of currently selected node (item/document)
  listOfCharLimits: any; // holds the list of metadata with charLimits
  alertMsg = ''; // holds alert message to be displayed for char limit while putting data
  existingValue = ''; // holds the existing field value of the current editor
  nodeSelectionEvent: Subscription; // holds subscription for node selection event
  clipboardReadPermission = true; // holds boolean to determine if clipboard error to be displayed
  constructor(private http: HttpClient, private sharedService: SharedService,  private treeDataService: TreeDataService) {
    this.updateField = new EventEmitter<any>();
    this.updateFieldOnChange = new EventEmitter<any>();
    this.updateShowEditor = new EventEmitter<any>();

    this.nodeSelectionEvent = this.sharedService.treeNodeSelectedEvent.subscribe((item: any) => {
      if (item && item.id) {
        this.onCancle();
      }
    });
  }

  ngOnInit() {
    this.getJSON().subscribe(data => {
      this.listOfCharLimits = data;
    });
  }

  ngOnDestroy(): void {
    if (this.nodeSelectionEvent) {
      this.nodeSelectionEvent.unsubscribe();
    }
  }

  public getJSON(): Observable<any> {
    try {
      return this.http.get('./assets/json/metadataCharLimit.json');
    } catch (err) { }
  }


  /* --------- Functionality to set data for rte from rteObject if exists or form object if not start --------- */

  setData(nodeTypeItem, formObj, formControlName, rteObject, category = 1) {
    this.fieldValue = '';
    if (rteObject) {
      for (const i in rteObject) {
        if (rteObject[i]['metadata_id'] === nodeTypeItem['metadata_id']) {
          this.fieldValue = rteObject[i]['htmlValue'];
          break;
        }
      }
    }
    this.metadata = nodeTypeItem;
    this.nodeCategory = category === 1 ? 'document' : 'item';
    if (this.fieldValue.length === 0) {
      this.fieldValue = formObj.value;
    }
    this.formControlName = formControlName;
  }

  /* --------- Functionality to set data for rte from rteObject if exists or form object if not end --------- */


  /* --------- Functionality to emit the updated object from rte to node details start --------- */

  updateData() {
    if (navigator.userAgent.match(/Edge/)) {
      const elements = document.getElementsByClassName('ngx-editor-textarea');
      for (const key in elements) {
        if (elements.hasOwnProperty(key)) {
          this.fieldValue = elements[key].innerHTML;
        }
      }
    } else {
      if (document.getElementsByClassName('ngx-editor-textarea') &&
        document.getElementsByClassName('ngx-editor-textarea')[0] &&
        document.getElementsByClassName('ngx-editor-textarea')[0].innerHTML) {
        this.fieldValue = document.getElementsByClassName('ngx-editor-textarea')[0].innerHTML;
      }
    }
    this.calculateOccupancy();

    return ({
      'metadata_id': this.metadata ? this.metadata.metadata_id : null,
      'is_custom': this.metadata ? this.metadata.is_custom : null,
      'formControlName': this.formControlName,
      'htmlValue': this.extractContent(this.fieldValue).length > 0 ? this.fieldValue : '',
      'value': this.extractContent(this.fieldValue).length > 0 ? this.fieldValue : '',
      'maxLimitExceeds': this.maxLimitExceeds
    });
  }


  // FUNCTION to calculate occupancy of total field capacity
  calculateOccupancy() {
    if (this.fieldValue !== undefined) {
      let charLimit = 0;
      let percentage = 0;
      if (this.metadata.internal_name !== 'notes' && this.metadata?.is_custom === 0) {
        charLimit = this.listOfCharLimits[this.metadata.internal_name];
      } else {
        const nodetype = this.metadata.is_document === 1 ? 'document' : 'item';
        this.nodeCategory = this.nodeCategory ? this.nodeCategory : nodetype;
        charLimit = this.listOfCharLimits[this.metadata.is_custom === 1
          ? 'custom'
          : this.metadata.internal_name][this.nodeCategory];
      }

      let actualPercentage = (this.fieldValue.length / charLimit) * 100;
      percentage = (Math.floor(actualPercentage) !== 100)
        ? Math.floor(actualPercentage)
        : actualPercentage;

      if (percentage === 0 && this.extractContent(this.fieldValue).length) {
        percentage = 1;
      } else if (!this.extractContent(this.fieldValue).length) {
        percentage = 0;
      }
      this.maxLimitExceeds = percentage > 100;
      this.containsBackslash = this.fieldValue.includes('\\');

      //To set Message if user has entered backslash.
      this.noBackslash = '';
      if(this.containsBackslash) {
        this.noBackslash = 'Use of Backslash is not permitted'
      }


      this.alertMsg = this.maxLimitExceeds
        ? 'Capacity of the field exceeded.'
        : ('Occupied ' + percentage + '% of the total field capacity.');

      
      let alertId = document.getElementById("alerContainer");
      if (this.maxLimitExceeds && alertId) {
        alertId.setAttribute('role', 'alert');
      }
      else if (!this.maxLimitExceeds && alertId
        &&  alertId.hasAttribute('role')
      ) {
        alertId.removeAttribute('role');
      }

      if(alertId) {
        (this.containsBackslash)
          ? alertId.setAttribute('role', 'alert')
          : alertId.removeAttribute('role')
      }
    }
  }

  /* UF-45813 - onPasteTitleData & onKeyPress functions to check validation for taxonomy title is removed */

  // Update data event emitting on update button click
  updateDataOnClick() {
    const obj = this.updateData();
    if (!this.maxLimitExceeds) {
      // added to decode the special characters
      obj.value = Utils.decodeTag(obj.value);
      obj.htmlValue =  Utils.decodeTag(obj.htmlValue);
      this.updateField.emit(obj);
      this.onCancle();
    }
  }

  // Update data event emitting on text change
  updateDataOnChange() {
    const obj = this.updateData();
    this.updateFieldOnChange.emit(obj);
  }

  /* --------- Functionality to emit the updated object from rte to node details end --------- */


  /* --------- Functionality to string from html content from rte start --------- */

  extractContent(html) {
    return (new DOMParser).parseFromString(html, 'text/html').documentElement.textContent;

  }

  /* --------- Functionality to string from html content from rte end --------- */

  onCancle() {
    this.updateShowEditor.emit(false);
  }

  // Function to handle paste event
  onPaste(e) {
    this.isPasting = true;
  }

  /* --------- Functionality to intercept the clipboard and clean the pre formatted data based on editor events start --------- */

  updateClipboard() {
    let plainText = '';
    navigator.clipboard.readText().then(
        clipText => {
          this.clipboardReadPermission = true;
          plainText = (new DOMParser).parseFromString(clipText, 'text/html').documentElement.textContent;
          navigator.clipboard.writeText(plainText);
        }).catch(ex => {
          if (ex.toString().indexOf('Read permission denied') !== -1) {
            this.clipboardReadPermission = false;
          }
        });
  }

  /* --------- Functionality to intercept the clipboard and clean the pre formatted data based on editor events end --------- */

}
